import axios from 'axios';

export interface cancelwaitingProps {
    loginId: string,
    paramId: string,
    eventUrl: string,
    rotaryCd: string
}

/**
 * キャンセル待ちに登録するAPIを呼び出す関数
 */
export async function setCancelWaiting(props: cancelwaitingProps): Promise<any> {
    try{
        const response = await axios.put(process.env.REACT_APP_PATH + `/users/me/event/cancelwaiting`, null, {
            params: {
                accountId: props.loginId,
                paramId: props.paramId,
                url: props.eventUrl,
                rotaryCd: props.rotaryCd
            },
            paramsSerializer:{
              indexes: null
            }
        });
        return JSON.parse(JSON.stringify(response.data[0]))

    }catch(err){
        console.error(err);
    }
}